<div class="col-lg-6 col-xs-12">

    <div class="panel panel-default">
        <div class="panel-body">

   <div style="display: block">
      <canvas baseChart
              [data]="polarAreaChartData"
              [labels]="polarAreaChartLabels"
              [legend]="polarAreaLegend"
              [chartType]="polarAreaChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)"></canvas>
    </div>

  </div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/report/charts/polar-area-chart/polar-area-chart.component.html